import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DynamicCssService } from '../../services/dynamic-css.service';

@Component({
  imports: [
    RouterOutlet
  ],
  selector: 'app-ambassador-layout',
  standalone: true,
  template: '<router-outlet></router-outlet>',
  styles: [
    `
    body {
      transition: opacity 0.3s ease-in-out;
    }
    `
  ]
})

export class AmbassadorLayoutComponent implements OnInit {
  constructor(private dynamicCss: DynamicCssService) {}

  ngOnInit() {
    document.body.style.opacity = '0';
    this.dynamicCss.loadStylesheetLink('public.css', 'public-css').then(() => {
      document.body.style.opacity = '1';
    });
  }
}
